module.exports = __webpack_public_path__ + "static/img/17.51ab4ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/17.png
// module id = yov+
// module chunks = 0